export const API_BASE_URL = 'https://api-tweb-efleet-justpay.justit.cloud/api';

export const API_ENDPOINTS = {
    supplierNetwork: (cnpj: string) => `/rede/${cnpj}`,
    vehicle: (plateOrCard: string) => `/veiculo/${plateOrCard}`,
    products: (vehicleId: number) => `/produtos/${vehicleId}`,
    balance: (plate: string, productId: number) => `/veiculo/${plate}/saldo/${productId}`,
    driver: (registration: string, clientId: number) => `/motorista/${registration}/${clientId}`,
    transactions: (supplierId: number) => `/transacao/${supplierId}`,
    paymentSale: '/pagamento/venda',
    uploadXml: '/xml',
} as const;

